import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton, Icon } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const CloseWarning = ({ button }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const navigate = useNavigate()
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  return (
    <>
      {button ? (
        <AdxButton variant={'ghost'} onClick={handleOpen} sx={{ width: '20%' }}>
          Back
        </AdxButton>
      ) : (
        <IconButton onClick={handleOpen}>
          <Icon sx={{ color: 'dark-text.main', fontSize: 20 }}>close</Icon>
        </IconButton>
      )}

      <AdxInfoModal
        variant={'error'}
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="error.main"
        title="Would you like to exit this page?"
        subtitle="Any unsaved changes will be discarded"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={() => navigate('/app/management-centre/staff-management/employee-file')}
        secondBtnLabel={'Close'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}

export default CloseWarning
